import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import {
  generateLocaleRoute,
  generateMyRoute,
  isParcelCreationRoute,
} from '../../utils/uri/uri.utils';
import { useStore } from '../../stores/store';
import { AppRoute } from '../../constants/route';
import { isFeatureRequired } from '../../utils/client/client.utils';

interface Props {
  mode: 'login' | 'logout' | 'tokenExpiring';
}

const Ouath2LoginRedirect = ({ mode }: Props) => {
  const {
    userStore: { setIsLogoutRequested },
    commonStore: { resetAppState, isGuestParcelCreation, landingPageUrl },
  } = useStore();

  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthEffect = async () => {
      if (mode === 'logout') {
        resetAppState();
        setIsLogoutRequested(false);

        if (isFeatureRequired('hasMarketingPage')) {
          const mainPageRoute = generateLocaleRoute();
          navigate(mainPageRoute, { replace: true });
        } else {
          window.location.replace(landingPageUrl);
        }

        return;
      }

      if (auth.isAuthenticated && auth.user) {
        const redirectUrl = (auth.user.state as { redirect?: string })
          ?.redirect;
        const preserveParcelCreationState = isParcelCreationRoute(redirectUrl);

        resetAppState({ preserveParcelCreationState });
        // Here just the redirect happens.
        // tokens are assigned and user profile is obtained in src/app/hooks/use-ouath-tokens.hooks.tsx
        const newRoute = redirectUrl || generateMyRoute(AppRoute.PARCEL_LIST);
        navigate(newRoute, { replace: true });
      }
    };

    if (mode !== 'login' && mode !== 'logout') return;

    handleAuthEffect();
  }, [
    auth.isAuthenticated,
    auth.user,
    auth.signoutRedirect,
    setIsLogoutRequested,
    navigate,
    resetAppState,
    mode,
    isGuestParcelCreation,
    landingPageUrl,
  ]);

  return null;
};

export default observer(Ouath2LoginRedirect);
